import React, { useState, useEffect } from 'react';

// import {SAVE_RESUME} from '../constants/constants'
import EditorSkills from './EditorSkills';
import EditorEducationHistory from './EditorEducationHistory';
import EditorWorkHistory from './EditorWorkHistory';
import BreadcrumComponent from './BreadcrumbComponent';
import Layout from './common/Layout';
import RightSection from './editor/RightSection';
import EditorHeading from './EditorHeading';
import AdditionalSections from './AdditionalSections';
import '../assets/scss/app/blocks/allinone-editor.scss';
import { useResume } from '../context/ResumeContext';
import { scroll2Id } from '../helper';
//import RearrangeSectionsPopup from './popup/RearrangeSectionsPopup';
import RearrangeSectionsComponent from './QuickEditor/RearrangeSectionsComponent';


const EditorSectionRearrange = (props) => {
  const [showRearrange, setShowRearrange] = useState(false);
  const {
    resume,
  } = useResume();
  const [openTabs, setopenTabs] = useState({
      heading:false,
      education:false,
      work_history:false,
      skills:false,
      summary: false,
      additional_sections: false
  });



  return (
    <Layout
      editorType="allinone"
      left={<RearrangeSectionsComponent 
          />
      }

      right={<RightSection current_tab={resume.current_tab} resume={resume} />}
      breadcrumb={!resume.enabled_tabs.includes('completed') ? <BreadcrumComponent enabled={resume.enabled_tabs} /> : false}
      leftPanel={props.leftPanel}
      showRearrange={true}
      setShowRearrange={(s) => setShowRearrange(s)}
    />
  );
}

export default EditorSectionRearrange;